<div class="webhooks-list-component">
  <div class="grid-view-with-filter-column">
    <div class="filter-column-container">
      <!-- Left Column -->
      <left-column class="col-auto left-column"
        [identifiers]="['filter']"
        [icons]="['filter']"
        #lc>
        @if (lc.show === 'filter' || !lc.show) {
          <filter-column
            [listFilter]=listFilter
            [filterConfig]="filterColumnConfig">
          </filter-column>
        }
      </left-column>
      <!-- Left Column end -->
    </div>
    <div class="view-container">
      <div class="filter-tabs-container">
      </div>
      <div class="main-view">
        <div class="grid-card">
          <div class="grid-card-header">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-start scroll-container" style="overflow-x: scroll">
                <filter-tags [filterConfig]="filterColumnConfig" class="d-flex flex-nowrap align-content-center align-items-center flex-grow-1"></filter-tags>
              </div>
              <div class="justify-content-end d-flex flex-row align-items-start ms-2">
                <button type="button"
                  class="btn btn-success btn-sm float-end btn-reload me-2"
                  (click)="getWebhooks()"
                  [disabled]="loading">
                  <fa-icon [icon]="['fas', 'sync-alt']" [fixedWidth]="true" [animation]="loading ? 'spin' : undefined"></fa-icon>
                </button>
                <filter-sorting [listFilter]="listFilter"
                  [filterConfig]="filterColumnConfig"
                ></filter-sorting>
              </div>
            </div>
          </div>
          <div class="grid-card-body">
            <ng-template #table_headers>
              <thead class="table-dark">
                <tr>
                  <th><div i18n="@@common.name">Name</div></th>
                  <th><div i18n="@@common.url">Url</div></th>
                  <th>
                    <div class="text-end">
                      <fa-icon [icon]="['fas', 'cloud-upload']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                      <span i18n="@@common.uploaded">Uploaded</span>
                    </div>
                  </th>
                  <th>
                    <div class="text-end">
                      <fa-icon [icon]="['fas', 'sync-alt']" transform="shrink-2" [fixedWidth]="true"></fa-icon>
                      <span i18n="@@common.updated">Updated</span>
                    </div>
                  </th>
                  <th><div>&nbsp;</div></th>
                </tr>
              </thead>
            </ng-template>

            <!-- Result -->
            @if (webhooks?.getModels().length > 0 && !loading) {
              <div class="table-responsive-new scroll-horizontal">
                <table class="table-new vertical-center">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                  <tbody>
                    @for (webhook of webhooks?.getModels(); track webhook) {
                      <tr [ngClass]="{ dim: !webhook.active }">
                        <td>
                          <list-data-with-tooltip [type]="'id'" [shouldTextClip]="true" [model]="webhook"></list-data-with-tooltip>
                        </td>
                        <td>{{ webhook.url }}</td>
                        <td class="text-nowrap text-end">
                          <list-data-with-tooltip [type]="'created_at'" [model]="webhook"></list-data-with-tooltip>
                        </td>
                        <td class="text-nowrap text-end">
                          <list-data-with-tooltip [type]="'updated_at'" [model]="webhook"></list-data-with-tooltip>
                        </td>
                        <td class="text-end align-middle btn-cell nodim">
                          <a type="button"
                            class="btn btn-xs btn-dark me-1 mb-1"
                            (click)="editWebhook(webhook.id, $event)"
                            [routerLink]="[webhook.id, 'edit']"
                            i18n-tooltip="@@components.webhooks.edit_webhook" tooltip="Edit webhook" container="body">
                            <fa-icon [icon]="['fas', 'pen']" [fixedWidth]="true"></fa-icon>
                          </a>
                          <a type="button"
                            class="btn btn-xs btn-dark me-1 mb-1 text-nowrap"
                            (click)="goToDetailView(webhook.id, $event)"
                            [routerLink]="[webhook.id, 'detail']">
                            <fa-icon [icon]="['fas', 'eye']" [fixedWidth]="true" class="me-1"></fa-icon>
                            <ng-container i18n="@@common.details">Details</ng-container>
                          </a>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <div class="table-responsive-new">
                <table class="table-new">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                </table>
                <div class="alert alert-warning mt-3" role="alert">
                  @if (loading) {
                    <fa-icon class="me-1" [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin"></fa-icon>
                  }
                  @if (loading) {
                    <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
                  } @else {
                    <ng-container i18n="@@common.nothing_here">There's nothing here!</ng-container>
                  }
                </div>
              </div>
            }
            <!-- Result end -->

            <!-- No Result -->
            <!-- No Result end -->
          </div>
          <div class="grid-card-footer">
            @if (webhooks?.getModels().length > 0) {
              <div>
                <list-pagination
                  [totalItems]="webhooks?.getMeta().meta.stats.total.count"
                  [filterComponent]="filterComponent"
                  [pageNumber]="listFilter.page.number"
                  [pageSize]="listFilter.page.size"
                ></list-pagination>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
